/* global angular, window, document, console, GlslCanvas */

(function () {
    "use strict";

    if (!Array.prototype.fill) {
        Object.defineProperty(Array.prototype, 'fill', {
            value: function (value) {

                // Steps 1-2.
                if (this == null) {
                    throw new TypeError('this is null or not defined');
                }

                var O = Object(this);

                // Steps 3-5.
                var len = O.length >>> 0;

                // Steps 6-7.
                var start = arguments[1];
                var relativeStart = start >> 0;

                // Step 8.
                var k = relativeStart < 0 ?
                    Math.max(len + relativeStart, 0) :
                    Math.min(relativeStart, len);

                // Steps 9-10.
                var end = arguments[2];
                var relativeEnd = end === undefined ?
                    len : end >> 0;

                // Step 11.
                var final = relativeEnd < 0 ?
                    Math.max(len + relativeEnd, 0) :
                    Math.min(relativeEnd, len);

                // Step 12.
                while (k < final) {
                    O[k] = value;
                    k++;
                }

                // Step 13.
                return O;
            }
        });
    }

    var app = angular.module('app');

    app.service('TrailService', [function () {
        var service = this;
        service.mouse = new Float32Array([0.0, 0.0]);
        service.history = [];
        service.trails = new Array(10).fill(null).map(function () {
            return new Float32Array([0.0, 0.0]);
        });

        var publics = {
            uniforms: uniforms,
            move: move,
            push: throttle(_push, 1000 / 60),
            update: update,
        };

        angular.extend(service, publics);

        // statics

        var getNow = Date.now || function () {
            return new Date().getTime();
        };

        function throttle(func, wait, options) {
            // Returns a function, that, when invoked, will only be triggered at most once
            // during a given window of time. Normally, the throttled function will run
            // as much as it can, without ever going more than once per `wait` duration;
            // but if you'd like to disable the execution on the leading edge, pass
            // `{leading: false}`. To disable execution on the trailing edge, ditto.
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function () {
                previous = options.leading === false ? 0 : getNow();
                timeout = null;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            };
            return function () {
                var now = getNow();
                if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                } else if (!timeout && options.trailing !== false) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }

        // publics

        var ti = 0;

        function loop() {
            var trails = service.trails,
                history = service.history,
                mouse = service.mouse;
            var i = 0,
                t = trails.length;
            var tx = history.length ? history[0] : mouse;
            while (i < t) {
                var e = (i > 0 ? trails[i - 1] : tx);
                var v = trails[i];
                var friction = 1.0 / (5.0 + i);
                v[0] += (e[0] - v[0]) * friction;
                v[1] += (e[1] - v[1]) * friction;
                i++;
            }
            if (history.length) {
                history.shift();
            }
            window.requestAnimationFrame(loop);
        }

        function uniforms(glsl, node) {
            var trails = service.trails;
            var i = 0,
                t = trails.length;
            while (i < t) {
                var x = trails[i][0];
                var y = trails[i][1];
                if (node) {
                    var rect = node.getBoundingClientRect();
                    x = x - rect.left;
                    y = rect.top + rect.height - y;
                }
                service.update(glsl, '2fv', 'vec2', 'u_trails[' + i + ']', new Float32Array([x, y]));
                i++;
            }
        }

        function update(glsl, method, type, name, value) {
            try {
                var u = glsl.uniforms[name] = glsl.uniforms[name] || {};
                u.name = name;
                u.value = value;
                u.type = type;
                u.method = 'uniform' + method;
                u.location = glsl.gl.getUniformLocation(glsl.program, name);
                glsl.gl[u.method].apply(glsl.gl, [u.location].concat(u.value));
            } catch (e) {
                console.log('fastUpdate', e);
            }
        }

        function move(x, y) {
            var service = this,
                mouse = service.mouse;
            mouse[0] = x;
            mouse[1] = y;
            service.push();
        }

        function _push() {
            service.history.push(new Float32Array(service.mouse));
        }

        angular.element(window).on('mousemove', function (e) {
            service.move(e.clientX, e.clientY);
            // console.log(e.clientY, document.querySelector('[water]').getBoundingClientRect().y);
        });

        loop();

    }]);

    app.service('WebGLCapabilities', [function () {
        var service = this;
        var gl;
        try {
            var canvas = document.createElement('canvas');
            if (!!window.WebGLRenderingContext) {
                gl = canvas.getContext('webgl', {
                        failIfMajorPerformanceCaveat: true
                    }) ||
                    canvas.getContext('experimental-webgl', {
                        failIfMajorPerformanceCaveat: true
                    });
            }
        } catch (e) {
            console.log('no webgl');
        }
        if (gl) {
            var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            service.debugInfo = debugInfo;
            service.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
            service.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
            service.has = true;
        }
        console.log('WebGLCapabilities.debugInfo', service.debugInfo);
        console.log('WebGLCapabilities.vendor', service.vendor);
        console.log('WebGLCapabilities.renderer', service.renderer);
    }]);

    app.directive('water', ['$parse', 'WebGLCapabilities', 'TrailService', 'CONFIG', function ($parse, WebGLCapabilities, TrailService, CONFIG) {

        function detectIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }
            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }
            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }
            // other browser
            return false;
        }

        var isIE = detectIE();

        return {
            restrict: 'A',
            template: '<canvas class="shader"></canvas>',
            link: function (scope, element, attributes) {

                if (CONFIG.app.url.indexOf('localhost') !== -1) {
                    return;
                }

                if (isIE) {
                    return;
                }

                if (!WebGLCapabilities.has) {
                    return;
                }

                var o = 1; // important
                var fragment = document.getElementById('fragment').innerHTML;
                var vertex = ''; // document.getElementById('vertex').innerHTML;
                var content = element[0];
                var canvas = element[0].querySelector('.shader');
                var trails = TrailService;

                onResize();

                var glsl = new GlslCanvas(canvas);
                glsl.on('error', onGlslError);

                load();

                function load() {
                    if (vertex.trim().length > 0) {
                        glsl.load(fragment, vertex);
                    } else if (fragment) {
                        glsl.load(fragment);
                    }
                    glsl.setUniform('u_mix', $parse(attributes.mix)(scope) || 0.5);
                    /*
                    for (var p in window.uniforms) {
                        glsl.setUniform(p, window.uniforms[p]);
                    }
                    for (var p in window.textures) {
                        glsl.setUniform('u_texture_' + p, window.textures[p]);
                    }
                    */
                    glsl.on('render', function () {
                        trails.uniforms(glsl, content);
                        glsl.forceRender = true;
                    });
                }

                function onResize() {
                    var w = content.offsetWidth + o;
                    var h = content.offsetHeight + o;
                    canvas.style.width = w + 'px';
                    canvas.style.height = h + 'px';
                    canvas.width = w;
                    canvas.height = h;
                    o = 0;
                }

                function onDown() {
                    if (glsl.paused) {
                        if (glsl.timePause) {
                            glsl.timePrev = new Date();
                            glsl.timeLoad += (glsl.timePrev - glsl.timePause);
                        }
                        glsl.play();
                    } else {
                        glsl.pause();
                        glsl.timePause = new Date();
                    }
                }

                function onGlslError(message) {
                    var errors = [],
                        warnings = [];
                    message.error.replace(/ERROR: \d+:(\d+): \'(.+)\' : (.+)/g, function (m, l, v, t) {
                        var li = '<li><a class="error" unselectable data-line="' + Number(l) + '" href="' + encodeURI('command:glsl-canvas.revealGlslLine?' + JSON.stringify([window.command, Number(l)])) + '"><span class="line">ERROR line ' + Number(l) + '</span> <span class="value" title="' + v + '">' + v + '</span> <span class="text" title="' + t + '">' + t + '</span></a></li>';
                        errors.push(li);
                        return li;
                    });
                    message.error.replace(/WARNING: \d+:(\d+): \'(.*\n*|.*|\n*)\' : (.+)/g, function (m, l, v, t) {
                        var li = '<li><a class="warning" unselectable data-line="' + Number(l) + '" href="' + encodeURI('command:glsl-canvas.revealGlslLine?' + JSON.stringify([window.command, Number(l)])) + '"><span class="line">WARN line ' + Number(l) + '</span> <span class="text" title="' + t + '">' + t + '</span></a></li>';
                        warnings.push(li);
                        return li;
                    });
                    console.log('onGlslError.error', errors, warnings);
                }

                canvas.addEventListener('mousedown', onDown);
                window.addEventListener('resize', onResize);
                onResize();
            }
        };
    }]);

}());